import React from 'react';

import {
  OrgInfoFormValues,
  OrgInfoFormViolation,
  OrgStaffCount,
} from 'types/orgInfoTypes';
import { createOrgInfoFormViolationLense } from 'utils/validateOrgInfoFormValues';
import { useAppState } from 'hooks/useAppState';
import { useAppDispatcher } from 'hooks/useAppDispatcher';

export const useProdStakcManagerOrgInfoForm = () => {
  const { orgInfoFormValues: values } = useAppState();

  const [violations, setViolations] = React.useState<OrgInfoFormViolation[]>(
    []
  );

  const dispatch = useAppDispatcher();

  const setValues = React.useCallback(
    (nextValues: OrgInfoFormValues) => {
      dispatch({
        name: 'ProdStackManager__OrgInfoFormValuesChanged',
        nextValues,
      });
    },
    [dispatch]
  );

  const changeName = React.useCallback(
    (nextValue: string) => {
      setValues({
        ...values,
        name: nextValue,
      });

      setViolations((prev) =>
        prev.filter(
          (violation) =>
            !createOrgInfoFormViolationLense(violation).isNameViolation()
        )
      );
    },
    [setValues, values]
  );

  const changeLocation = React.useCallback(
    (nextValue: string) => {
      setValues({
        ...values,
        location: nextValue,
      });

      setViolations((prev) =>
        prev.filter(
          (violation) =>
            !createOrgInfoFormViolationLense(violation).isLocationViolation()
        )
      );
    },
    [setValues, values]
  );

  const changeStaffCount = React.useCallback(
    (nextValue: OrgStaffCount) => {
      setValues({
        ...values,
        staffCount: nextValue,
      });

      setViolations((prev) =>
        prev.filter(
          (violation) =>
            !createOrgInfoFormViolationLense(violation).isStaffCountViolation()
        )
      );
    },
    [setValues, values]
  );

  return {
    values,
    violations,
    setValues,
    setViolations,
    changeLocation,
    changeName,
    changeStaffCount,
  };
};
